// generated with @7nohe/openapi-react-query-codegen@2.0.0

import { type Options } from "@hey-api/client-fetch";
import {
  UseMutationOptions,
  UseQueryOptions,
  useMutation,
  useQuery,
} from "@tanstack/react-query";
import {
  acceptOffer,
  addFormSchoolTag,
  addFormTag,
  addOfferingSeatTypes,
  archiveTeamMembers,
  bulkAcceptOffer,
  bulkDeclineOffer,
  bulkGetOfferExpirationInfo,
  bulkMakeOffers,
  bulkRevokeOffer,
  bulkSetOfferExpiration,
  cancelPayment,
  checkout,
  clearAnswer,
  clearAnswerForMe,
  clearSubStatus,
  connectStripeAccount,
  createApiCredential,
  createBoundaryConnections,
  createBulkFormAction,
  createBulkFormTagAction,
  createBulkOfferAction,
  createBulkSubstatusAction,
  createBulkWaitlistAction,
  createFormRule,
  createFormTemplate,
  createLoginPrefillToken,
  createOfferConfiguration,
  createOfferingCategories,
  createOfferings,
  createOrganization,
  createPaymentTemplate,
  createPayments,
  createRuleExecutions,
  createRuleExecutionsForMe,
  createTag,
  createTagGroup,
  createTeamMember,
  declineOffer,
  deleteApiCredential,
  deleteBoundaries,
  deleteBoundaryConnections,
  deleteFormForMe,
  deleteFormRule,
  deleteOfferConfiguration,
  deleteOffering,
  deleteOfferingCategory,
  deleteOfferingSeatType,
  deletePaymentTemplate,
  deleteTag,
  deleteTagGroup,
  deleteUnpublishedFormSchema,
  deleteWaitlists,
  diffFormSchema,
  disconnectStripeAccount,
  editTeamMember,
  exclude,
  exportBoundariesByOrgGeoJson,
  exportBoundaryGeoJson,
  exportBulkActionItems,
  exportCapacitiesByEnrollmentPeriod,
  exportCapacitiesBySchoolAndEnrollmentPeriod,
  exportFormTemplate,
  exportMessageTemplates,
  exportRuleConfiguration,
  exportSchoolBoundaryConnections,
  exportSchoolsAndGradesForEnrollmentPeriod,
  fetchFormSchoolTags,
  fetchFormTags,
  fetchTagGroups,
  fetchTags,
  generateBannerImageUploadUrl,
  generateUploadUrl,
  geocodeAnswer,
  geocodeForms,
  getAdminGreeting,
  getAdminPaymentReceipt,
  getAdmissionsForMe,
  getAnswers,
  getAnswersForMe,
  getApiCredential,
  getBoundaries,
  getBoundariesByOrgId,
  getBoundariesMetadata,
  getBoundaryConnectionsBySchoolId,
  getBoundaryMapByEnrollmentPeriodId,
  getBoundaryMapByEnrollmentPeriodIdOptimized,
  getBoundaryMapByFormId,
  getBoundaryMapByFormIdOptimized,
  getBulkAction,
  getBulkActionProgress,
  getCapacitiesBySchoolAndEnrollmentPeriod,
  getCapacitiesConfigByEnrollmentPeriod,
  getCapacitiesHistory,
  getCapacitiesHistoryDetail,
  getCapacitySummaryByEnrollmentPeriod,
  getDashboardFormResponsesOverTime,
  getDashboardFormSchoolGradeRank,
  getDashboardFormStatus,
  getDashboardFormSubstatus,
  getEligibleFormTemplatesForApplicant,
  getEligibleFormTemplatesForMe,
  getForm,
  getFormAlertsByFormId,
  getFormRule,
  getFormTemplate,
  getFormTemplateSettings,
  getFormTemplateSettingsForMe,
  getForms,
  getGradeConfigByEnrollmentPeriod,
  getOfferConfigurationById,
  getOfferConfigurationsByEnrollmentPeriodId,
  getOfferConfigurationsByFormTemplateId,
  getOfferingCategories,
  getOfferings,
  getOffersForMe,
  getOrganizationConfig,
  getPaymentReceipt,
  getPaymentTemplate,
  getPaymentsForMe,
  getSchools,
  getSchoolsByEnrollmentPeriod,
  getTagUsageCount,
  importBoundaryConnectionsFromEnrollmentPeriod,
  importCapacitiesByEnrollmentPeriod,
  importFormTemplateFromJson,
  importFormTemplateFromOther,
  importMessageTemplates,
  importMessageTemplatesFromOther,
  importRuleConfiguration,
  importSchoolBoundaryConnections,
  importSchoolsAndGradesForEnrollmentPeriod,
  importSchoolsAndGradesFromOthersForEnrollmentPeriod,
  listAllowedSubStatusTransitions,
  listApiCredentials,
  listBulkActionItems,
  listBulkActions,
  listCapacitiesByEnrollmentPeriod,
  listCapacitiesBySchoolAndEnrollmentPeriod,
  listFormIds,
  listFormIdsAdvanced,
  listFormIdsAdvancedV2,
  listFormIdsV2,
  listFormTemplatesSettings,
  listForms,
  listFormsAdvanced,
  listFormsFromSelection,
  listPaymentTemplates,
  listPayments,
  listTeams,
  listUserGroups,
  parentGetBoundaryMapByEnrollmentPeriodId,
  parentGetBoundaryMapByEnrollmentPeriodIdOptimized,
  parentGetBoundaryMapByFormId,
  parentGetBoundaryMapByFormIdOptimized,
  postBoundaries,
  postWaitlists,
  publishFormSchema,
  publishMatchRun,
  putAnswer,
  putAnswerForMe,
  putAnswers,
  putAnswersForMe,
  removeFormSchoolTag,
  removeFormTag,
  resendVerificationEmail,
  resetFormForMe,
  resetTeamMemberMfa,
  rotateApiCredentialSecret,
  searchApplicants,
  sendPasswordReset,
  submitFormForMe,
  updateApiCredential,
  updateBoundaryById,
  updateBoundaryConnections,
  updateCapacitiesByEnrollmentPeriod,
  updateCapacitiesConfigByEnrollmentPeriod,
  updateFormRule,
  updateFormRuleActiveStatus,
  updateFormSchema,
  updateFormTemplate,
  updateFormTemplateSettings,
  updateFormsStatusForAdmin,
  updateOfferConfiguration,
  updateOfferingCategory,
  updateOrganizationConfig,
  updatePaymentTemplate,
  updateTag,
  updateTagGroup,
  validateFormSchema,
  withdrawFromWaitlist,
} from "../requests/services.gen";
import {
  AcceptOfferData,
  AcceptOfferError,
  AddFormSchoolTagData,
  AddFormSchoolTagError,
  AddFormTagData,
  AddFormTagError,
  AddOfferingSeatTypesData,
  AddOfferingSeatTypesError,
  ArchiveTeamMembersData,
  ArchiveTeamMembersError,
  BulkAcceptOfferData,
  BulkAcceptOfferError,
  BulkDeclineOfferData,
  BulkDeclineOfferError,
  BulkGetOfferExpirationInfoData,
  BulkGetOfferExpirationInfoError,
  BulkMakeOffersData,
  BulkMakeOffersError,
  BulkRevokeOfferData,
  BulkRevokeOfferError,
  BulkSetOfferExpirationData,
  BulkSetOfferExpirationError,
  CancelPaymentData,
  CancelPaymentError,
  CheckoutData,
  CheckoutError,
  ClearAnswerData,
  ClearAnswerError,
  ClearAnswerForMeData,
  ClearAnswerForMeError,
  ClearSubStatusData,
  ClearSubStatusError,
  ConnectStripeAccountData,
  ConnectStripeAccountError,
  CreateApiCredentialData,
  CreateApiCredentialError,
  CreateBoundaryConnectionsData,
  CreateBoundaryConnectionsError,
  CreateBulkFormActionData,
  CreateBulkFormActionError,
  CreateBulkFormTagActionData,
  CreateBulkFormTagActionError,
  CreateBulkOfferActionData,
  CreateBulkOfferActionError,
  CreateBulkSubstatusActionData,
  CreateBulkSubstatusActionError,
  CreateBulkWaitlistActionData,
  CreateBulkWaitlistActionError,
  CreateFormRuleData,
  CreateFormRuleError,
  CreateFormTemplateData,
  CreateFormTemplateError,
  CreateLoginPrefillTokenData,
  CreateLoginPrefillTokenError,
  CreateOfferConfigurationData,
  CreateOfferConfigurationError,
  CreateOfferingCategoriesData,
  CreateOfferingCategoriesError,
  CreateOfferingsData,
  CreateOfferingsError,
  CreateOrganizationData,
  CreateOrganizationError,
  CreatePaymentTemplateData,
  CreatePaymentTemplateError,
  CreatePaymentsData,
  CreatePaymentsError,
  CreateRuleExecutionsData,
  CreateRuleExecutionsError,
  CreateRuleExecutionsForMeData,
  CreateRuleExecutionsForMeError,
  CreateTagData,
  CreateTagError,
  CreateTagGroupData,
  CreateTagGroupError,
  CreateTeamMemberData,
  CreateTeamMemberError,
  DeclineOfferData,
  DeclineOfferError,
  DeleteApiCredentialData,
  DeleteApiCredentialError,
  DeleteBoundariesData,
  DeleteBoundariesError,
  DeleteBoundaryConnectionsData,
  DeleteBoundaryConnectionsError,
  DeleteFormForMeData,
  DeleteFormForMeError,
  DeleteFormRuleData,
  DeleteFormRuleError,
  DeleteOfferConfigurationData,
  DeleteOfferConfigurationError,
  DeleteOfferingCategoryData,
  DeleteOfferingCategoryError,
  DeleteOfferingData,
  DeleteOfferingError,
  DeleteOfferingSeatTypeData,
  DeleteOfferingSeatTypeError,
  DeletePaymentTemplateData,
  DeletePaymentTemplateError,
  DeleteTagData,
  DeleteTagError,
  DeleteTagGroupData,
  DeleteTagGroupError,
  DeleteUnpublishedFormSchemaData,
  DeleteUnpublishedFormSchemaError,
  DeleteWaitlistsData,
  DeleteWaitlistsError,
  DiffFormSchemaData,
  DiffFormSchemaError,
  DisconnectStripeAccountData,
  DisconnectStripeAccountError,
  EditTeamMemberData,
  EditTeamMemberError,
  ExcludeData,
  ExcludeError,
  ExportBoundariesByOrgGeoJsonData,
  ExportBoundariesByOrgGeoJsonError,
  ExportBoundaryGeoJsonData,
  ExportBoundaryGeoJsonError,
  ExportBulkActionItemsData,
  ExportBulkActionItemsError,
  ExportCapacitiesByEnrollmentPeriodData,
  ExportCapacitiesByEnrollmentPeriodError,
  ExportCapacitiesBySchoolAndEnrollmentPeriodData,
  ExportCapacitiesBySchoolAndEnrollmentPeriodError,
  ExportFormTemplateData,
  ExportFormTemplateError,
  ExportMessageTemplatesData,
  ExportMessageTemplatesError,
  ExportRuleConfigurationData,
  ExportRuleConfigurationError,
  ExportSchoolBoundaryConnectionsData,
  ExportSchoolBoundaryConnectionsError,
  ExportSchoolsAndGradesForEnrollmentPeriodData,
  ExportSchoolsAndGradesForEnrollmentPeriodError,
  FetchFormSchoolTagsData,
  FetchFormSchoolTagsError,
  FetchFormTagsData,
  FetchFormTagsError,
  FetchTagGroupsData,
  FetchTagGroupsError,
  FetchTagsData,
  FetchTagsError,
  GenerateBannerImageUploadUrlData,
  GenerateBannerImageUploadUrlError,
  GenerateUploadUrlData,
  GenerateUploadUrlError,
  GeocodeAnswerData,
  GeocodeAnswerError,
  GeocodeFormsData,
  GeocodeFormsError,
  GetAdminGreetingData,
  GetAdminGreetingError,
  GetAdminPaymentReceiptData,
  GetAdminPaymentReceiptError,
  GetAdmissionsForMeData,
  GetAdmissionsForMeError,
  GetAnswersData,
  GetAnswersError,
  GetAnswersForMeData,
  GetAnswersForMeError,
  GetApiCredentialData,
  GetApiCredentialError,
  GetBoundariesByOrgIdData,
  GetBoundariesByOrgIdError,
  GetBoundariesData,
  GetBoundariesError,
  GetBoundariesMetadataData,
  GetBoundariesMetadataError,
  GetBoundaryConnectionsBySchoolIdData,
  GetBoundaryConnectionsBySchoolIdError,
  GetBoundaryMapByEnrollmentPeriodIdData,
  GetBoundaryMapByEnrollmentPeriodIdError,
  GetBoundaryMapByEnrollmentPeriodIdOptimizedData,
  GetBoundaryMapByEnrollmentPeriodIdOptimizedError,
  GetBoundaryMapByFormIdData,
  GetBoundaryMapByFormIdError,
  GetBoundaryMapByFormIdOptimizedData,
  GetBoundaryMapByFormIdOptimizedError,
  GetBulkActionData,
  GetBulkActionError,
  GetBulkActionProgressData,
  GetBulkActionProgressError,
  GetCapacitiesBySchoolAndEnrollmentPeriodData,
  GetCapacitiesBySchoolAndEnrollmentPeriodError,
  GetCapacitiesConfigByEnrollmentPeriodData,
  GetCapacitiesConfigByEnrollmentPeriodError,
  GetCapacitiesHistoryData,
  GetCapacitiesHistoryDetailData,
  GetCapacitiesHistoryDetailError,
  GetCapacitiesHistoryError,
  GetCapacitySummaryByEnrollmentPeriodData,
  GetCapacitySummaryByEnrollmentPeriodError,
  GetDashboardFormResponsesOverTimeData,
  GetDashboardFormResponsesOverTimeError,
  GetDashboardFormSchoolGradeRankData,
  GetDashboardFormSchoolGradeRankError,
  GetDashboardFormStatusData,
  GetDashboardFormStatusError,
  GetDashboardFormSubstatusData,
  GetDashboardFormSubstatusError,
  GetEligibleFormTemplatesForApplicantData,
  GetEligibleFormTemplatesForApplicantError,
  GetEligibleFormTemplatesForMeData,
  GetEligibleFormTemplatesForMeError,
  GetFormAlertsByFormIdData,
  GetFormAlertsByFormIdError,
  GetFormData,
  GetFormError,
  GetFormRuleData,
  GetFormRuleError,
  GetFormTemplateData,
  GetFormTemplateError,
  GetFormTemplateSettingsData,
  GetFormTemplateSettingsError,
  GetFormTemplateSettingsForMeData,
  GetFormTemplateSettingsForMeError,
  GetFormsData,
  GetFormsError,
  GetGradeConfigByEnrollmentPeriodData,
  GetGradeConfigByEnrollmentPeriodError,
  GetOfferConfigurationByIdData,
  GetOfferConfigurationByIdError,
  GetOfferConfigurationsByEnrollmentPeriodIdData,
  GetOfferConfigurationsByEnrollmentPeriodIdError,
  GetOfferConfigurationsByFormTemplateIdData,
  GetOfferConfigurationsByFormTemplateIdError,
  GetOfferingCategoriesData,
  GetOfferingCategoriesError,
  GetOfferingsData,
  GetOfferingsError,
  GetOffersForMeData,
  GetOffersForMeError,
  GetOrganizationConfigData,
  GetOrganizationConfigError,
  GetPaymentReceiptData,
  GetPaymentReceiptError,
  GetPaymentTemplateData,
  GetPaymentTemplateError,
  GetPaymentsForMeData,
  GetPaymentsForMeError,
  GetSchoolsByEnrollmentPeriodData,
  GetSchoolsByEnrollmentPeriodError,
  GetSchoolsData,
  GetSchoolsError,
  GetTagUsageCountData,
  GetTagUsageCountError,
  ImportBoundaryConnectionsFromEnrollmentPeriodData,
  ImportBoundaryConnectionsFromEnrollmentPeriodError,
  ImportCapacitiesByEnrollmentPeriodData,
  ImportCapacitiesByEnrollmentPeriodError,
  ImportFormTemplateFromJsonData,
  ImportFormTemplateFromJsonError,
  ImportFormTemplateFromOtherData,
  ImportFormTemplateFromOtherError,
  ImportMessageTemplatesData,
  ImportMessageTemplatesError,
  ImportMessageTemplatesFromOtherData,
  ImportMessageTemplatesFromOtherError,
  ImportRuleConfigurationData,
  ImportRuleConfigurationError,
  ImportSchoolBoundaryConnectionsData,
  ImportSchoolBoundaryConnectionsError,
  ImportSchoolsAndGradesForEnrollmentPeriodData,
  ImportSchoolsAndGradesForEnrollmentPeriodError,
  ImportSchoolsAndGradesFromOthersForEnrollmentPeriodData,
  ImportSchoolsAndGradesFromOthersForEnrollmentPeriodError,
  ListAllowedSubStatusTransitionsData,
  ListAllowedSubStatusTransitionsError,
  ListApiCredentialsData,
  ListApiCredentialsError,
  ListBulkActionItemsData,
  ListBulkActionItemsError,
  ListBulkActionsData,
  ListBulkActionsError,
  ListCapacitiesByEnrollmentPeriodData,
  ListCapacitiesByEnrollmentPeriodError,
  ListCapacitiesBySchoolAndEnrollmentPeriodData,
  ListCapacitiesBySchoolAndEnrollmentPeriodError,
  ListFormIdsAdvancedData,
  ListFormIdsAdvancedError,
  ListFormIdsAdvancedV2Data,
  ListFormIdsAdvancedV2Error,
  ListFormIdsData,
  ListFormIdsError,
  ListFormIdsV2Data,
  ListFormIdsV2Error,
  ListFormTemplatesSettingsData,
  ListFormTemplatesSettingsError,
  ListFormsAdvancedData,
  ListFormsAdvancedError,
  ListFormsData,
  ListFormsError,
  ListFormsFromSelectionData,
  ListFormsFromSelectionError,
  ListPaymentTemplatesData,
  ListPaymentTemplatesError,
  ListPaymentsData,
  ListPaymentsError,
  ListTeamsData,
  ListTeamsError,
  ListUserGroupsError,
  ParentGetBoundaryMapByEnrollmentPeriodIdData,
  ParentGetBoundaryMapByEnrollmentPeriodIdError,
  ParentGetBoundaryMapByEnrollmentPeriodIdOptimizedData,
  ParentGetBoundaryMapByEnrollmentPeriodIdOptimizedError,
  ParentGetBoundaryMapByFormIdData,
  ParentGetBoundaryMapByFormIdError,
  ParentGetBoundaryMapByFormIdOptimizedData,
  ParentGetBoundaryMapByFormIdOptimizedError,
  PostBoundariesData,
  PostBoundariesError,
  PostWaitlistsData,
  PostWaitlistsError,
  PublishFormSchemaData,
  PublishFormSchemaError,
  PublishMatchRunData,
  PublishMatchRunError,
  PutAnswerData,
  PutAnswerError,
  PutAnswerForMeData,
  PutAnswerForMeError,
  PutAnswersData,
  PutAnswersError,
  PutAnswersForMeData,
  PutAnswersForMeError,
  RemoveFormSchoolTagData,
  RemoveFormSchoolTagError,
  RemoveFormTagData,
  RemoveFormTagError,
  ResendVerificationEmailData,
  ResendVerificationEmailError,
  ResetFormForMeData,
  ResetFormForMeError,
  ResetTeamMemberMfaData,
  ResetTeamMemberMfaError,
  RotateApiCredentialSecretData,
  RotateApiCredentialSecretError,
  SearchApplicantsData,
  SearchApplicantsError,
  SendPasswordResetData,
  SendPasswordResetError,
  SubmitFormForMeData,
  SubmitFormForMeError,
  UpdateApiCredentialData,
  UpdateApiCredentialError,
  UpdateBoundaryByIdData,
  UpdateBoundaryByIdError,
  UpdateBoundaryConnectionsData,
  UpdateBoundaryConnectionsError,
  UpdateCapacitiesByEnrollmentPeriodData,
  UpdateCapacitiesByEnrollmentPeriodError,
  UpdateCapacitiesConfigByEnrollmentPeriodData,
  UpdateCapacitiesConfigByEnrollmentPeriodError,
  UpdateFormRuleActiveStatusData,
  UpdateFormRuleActiveStatusError,
  UpdateFormRuleData,
  UpdateFormRuleError,
  UpdateFormSchemaData,
  UpdateFormSchemaError,
  UpdateFormTemplateData,
  UpdateFormTemplateError,
  UpdateFormTemplateSettingsData,
  UpdateFormTemplateSettingsError,
  UpdateFormsStatusForAdminData,
  UpdateFormsStatusForAdminError,
  UpdateOfferConfigurationData,
  UpdateOfferConfigurationError,
  UpdateOfferingCategoryData,
  UpdateOfferingCategoryError,
  UpdateOrganizationConfigData,
  UpdateOrganizationConfigError,
  UpdatePaymentTemplateData,
  UpdatePaymentTemplateError,
  UpdateTagData,
  UpdateTagError,
  UpdateTagGroupData,
  UpdateTagGroupError,
  ValidateFormSchemaData,
  ValidateFormSchemaError,
  WithdrawFromWaitlistData,
  WithdrawFromWaitlistError,
} from "../requests/types.gen";
import * as Common from "./common";
export const useGetForm = <
  TData = Common.GetFormDefaultResponse,
  TError = GetFormError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetFormData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetFormKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getForm({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetAnswers = <
  TData = Common.GetAnswersDefaultResponse,
  TError = GetAnswersError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetAnswersData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetAnswersKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getAnswers({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetOfferConfigurationById = <
  TData = Common.GetOfferConfigurationByIdDefaultResponse,
  TError = GetOfferConfigurationByIdError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetOfferConfigurationByIdData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetOfferConfigurationByIdKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getOfferConfigurationById({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetOfferConfigurationsByEnrollmentPeriodId = <
  TData = Common.GetOfferConfigurationsByEnrollmentPeriodIdDefaultResponse,
  TError = GetOfferConfigurationsByEnrollmentPeriodIdError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetOfferConfigurationsByEnrollmentPeriodIdData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetOfferConfigurationsByEnrollmentPeriodIdKeyFn(
      clientOptions,
      queryKey
    ),
    queryFn: () =>
      getOfferConfigurationsByEnrollmentPeriodId({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetOfferConfigurationsByFormTemplateId = <
  TData = Common.GetOfferConfigurationsByFormTemplateIdDefaultResponse,
  TError = GetOfferConfigurationsByFormTemplateIdError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetOfferConfigurationsByFormTemplateIdData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetOfferConfigurationsByFormTemplateIdKeyFn(
      clientOptions,
      queryKey
    ),
    queryFn: () =>
      getOfferConfigurationsByFormTemplateId({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useListForms = <
  TData = Common.ListFormsDefaultResponse,
  TError = ListFormsError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<ListFormsData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseListFormsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listForms({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useListFormIds = <
  TData = Common.ListFormIdsDefaultResponse,
  TError = ListFormIdsError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<ListFormIdsData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseListFormIdsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listFormIds({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useListFormIdsV2 = <
  TData = Common.ListFormIdsV2DefaultResponse,
  TError = ListFormIdsV2Error,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<ListFormIdsV2Data, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseListFormIdsV2KeyFn(clientOptions, queryKey),
    queryFn: () =>
      listFormIdsV2({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useListBulkActions = <
  TData = Common.ListBulkActionsDefaultResponse,
  TError = ListBulkActionsError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<ListBulkActionsData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseListBulkActionsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listBulkActions({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetBulkActionProgress = <
  TData = Common.GetBulkActionProgressDefaultResponse,
  TError = GetBulkActionProgressError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetBulkActionProgressData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetBulkActionProgressKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getBulkActionProgress({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetBulkAction = <
  TData = Common.GetBulkActionDefaultResponse,
  TError = GetBulkActionError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetBulkActionData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetBulkActionKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getBulkAction({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useExportBulkActionItems = <
  TData = Common.ExportBulkActionItemsDefaultResponse,
  TError = ExportBulkActionItemsError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<ExportBulkActionItemsData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseExportBulkActionItemsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      exportBulkActionItems({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useListBulkActionItems = <
  TData = Common.ListBulkActionItemsDefaultResponse,
  TError = ListBulkActionItemsError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<ListBulkActionItemsData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseListBulkActionItemsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listBulkActionItems({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useFetchFormTags = <
  TData = Common.FetchFormTagsDefaultResponse,
  TError = FetchFormTagsError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<FetchFormTagsData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseFetchFormTagsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      fetchFormTags({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useFetchFormSchoolTags = <
  TData = Common.FetchFormSchoolTagsDefaultResponse,
  TError = FetchFormSchoolTagsError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<FetchFormSchoolTagsData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseFetchFormSchoolTagsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      fetchFormSchoolTags({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useFetchTagGroups = <
  TData = Common.FetchTagGroupsDefaultResponse,
  TError = FetchTagGroupsError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<FetchTagGroupsData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseFetchTagGroupsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      fetchTagGroups({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useFetchTags = <
  TData = Common.FetchTagsDefaultResponse,
  TError = FetchTagsError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<FetchTagsData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseFetchTagsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      fetchTags({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetTagUsageCount = <
  TData = Common.GetTagUsageCountDefaultResponse,
  TError = GetTagUsageCountError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetTagUsageCountData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetTagUsageCountKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getTagUsageCount({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useExportRuleConfiguration = <
  TData = Common.ExportRuleConfigurationDefaultResponse,
  TError = ExportRuleConfigurationError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<ExportRuleConfigurationData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseExportRuleConfigurationKeyFn(clientOptions, queryKey),
    queryFn: () =>
      exportRuleConfiguration({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetEligibleFormTemplatesForApplicant = <
  TData = Common.GetEligibleFormTemplatesForApplicantDefaultResponse,
  TError = GetEligibleFormTemplatesForApplicantError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetEligibleFormTemplatesForApplicantData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetEligibleFormTemplatesForApplicantKeyFn(
      clientOptions,
      queryKey
    ),
    queryFn: () =>
      getEligibleFormTemplatesForApplicant({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useListFormTemplatesSettings = <
  TData = Common.ListFormTemplatesSettingsDefaultResponse,
  TError = ListFormTemplatesSettingsError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<ListFormTemplatesSettingsData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseListFormTemplatesSettingsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listFormTemplatesSettings({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetFormTemplate = <
  TData = Common.GetFormTemplateDefaultResponse,
  TError = GetFormTemplateError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetFormTemplateData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetFormTemplateKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getFormTemplate({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetFormTemplateSettings = <
  TData = Common.GetFormTemplateSettingsDefaultResponse,
  TError = GetFormTemplateSettingsError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetFormTemplateSettingsData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetFormTemplateSettingsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getFormTemplateSettings({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useExportFormTemplate = <
  TData = Common.ExportFormTemplateDefaultResponse,
  TError = ExportFormTemplateError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<ExportFormTemplateData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseExportFormTemplateKeyFn(clientOptions, queryKey),
    queryFn: () =>
      exportFormTemplate({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetFormRule = <
  TData = Common.GetFormRuleDefaultResponse,
  TError = GetFormRuleError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetFormRuleData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetFormRuleKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getFormRule({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useExportMessageTemplates = <
  TData = Common.ExportMessageTemplatesDefaultResponse,
  TError = ExportMessageTemplatesError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<ExportMessageTemplatesData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseExportMessageTemplatesKeyFn(clientOptions, queryKey),
    queryFn: () =>
      exportMessageTemplates({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useExportSchoolsAndGradesForEnrollmentPeriod = <
  TData = Common.ExportSchoolsAndGradesForEnrollmentPeriodDefaultResponse,
  TError = ExportSchoolsAndGradesForEnrollmentPeriodError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<ExportSchoolsAndGradesForEnrollmentPeriodData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseExportSchoolsAndGradesForEnrollmentPeriodKeyFn(
      clientOptions,
      queryKey
    ),
    queryFn: () =>
      exportSchoolsAndGradesForEnrollmentPeriod({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useExportSchoolBoundaryConnections = <
  TData = Common.ExportSchoolBoundaryConnectionsDefaultResponse,
  TError = ExportSchoolBoundaryConnectionsError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<ExportSchoolBoundaryConnectionsData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseExportSchoolBoundaryConnectionsKeyFn(
      clientOptions,
      queryKey
    ),
    queryFn: () =>
      exportSchoolBoundaryConnections({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetOfferingCategories = <
  TData = Common.GetOfferingCategoriesDefaultResponse,
  TError = GetOfferingCategoriesError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetOfferingCategoriesData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetOfferingCategoriesKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getOfferingCategories({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetOfferings = <
  TData = Common.GetOfferingsDefaultResponse,
  TError = GetOfferingsError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetOfferingsData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetOfferingsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getOfferings({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetBoundaryConnectionsBySchoolId = <
  TData = Common.GetBoundaryConnectionsBySchoolIdDefaultResponse,
  TError = GetBoundaryConnectionsBySchoolIdError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetBoundaryConnectionsBySchoolIdData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetBoundaryConnectionsBySchoolIdKeyFn(
      clientOptions,
      queryKey
    ),
    queryFn: () =>
      getBoundaryConnectionsBySchoolId({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetBoundaries = <
  TData = Common.GetBoundariesDefaultResponse,
  TError = GetBoundariesError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetBoundariesData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetBoundariesKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getBoundaries({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetBoundariesMetadata = <
  TData = Common.GetBoundariesMetadataDefaultResponse,
  TError = GetBoundariesMetadataError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetBoundariesMetadataData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetBoundariesMetadataKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getBoundariesMetadata({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetBoundariesByOrgId = <
  TData = Common.GetBoundariesByOrgIdDefaultResponse,
  TError = GetBoundariesByOrgIdError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetBoundariesByOrgIdData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetBoundariesByOrgIdKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getBoundariesByOrgId({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useExportBoundaryGeoJson = <
  TData = Common.ExportBoundaryGeoJsonDefaultResponse,
  TError = ExportBoundaryGeoJsonError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<ExportBoundaryGeoJsonData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseExportBoundaryGeoJsonKeyFn(clientOptions, queryKey),
    queryFn: () =>
      exportBoundaryGeoJson({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useExportBoundariesByOrgGeoJson = <
  TData = Common.ExportBoundariesByOrgGeoJsonDefaultResponse,
  TError = ExportBoundariesByOrgGeoJsonError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<ExportBoundariesByOrgGeoJsonData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseExportBoundariesByOrgGeoJsonKeyFn(
      clientOptions,
      queryKey
    ),
    queryFn: () =>
      exportBoundariesByOrgGeoJson({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetBoundaryMapByFormId = <
  TData = Common.GetBoundaryMapByFormIdDefaultResponse,
  TError = GetBoundaryMapByFormIdError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetBoundaryMapByFormIdData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetBoundaryMapByFormIdKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getBoundaryMapByFormId({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetBoundaryMapByEnrollmentPeriodId = <
  TData = Common.GetBoundaryMapByEnrollmentPeriodIdDefaultResponse,
  TError = GetBoundaryMapByEnrollmentPeriodIdError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetBoundaryMapByEnrollmentPeriodIdData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetBoundaryMapByEnrollmentPeriodIdKeyFn(
      clientOptions,
      queryKey
    ),
    queryFn: () =>
      getBoundaryMapByEnrollmentPeriodId({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetBoundaryMapByFormIdOptimized = <
  TData = Common.GetBoundaryMapByFormIdOptimizedDefaultResponse,
  TError = GetBoundaryMapByFormIdOptimizedError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetBoundaryMapByFormIdOptimizedData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetBoundaryMapByFormIdOptimizedKeyFn(
      clientOptions,
      queryKey
    ),
    queryFn: () =>
      getBoundaryMapByFormIdOptimized({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetBoundaryMapByEnrollmentPeriodIdOptimized = <
  TData = Common.GetBoundaryMapByEnrollmentPeriodIdOptimizedDefaultResponse,
  TError = GetBoundaryMapByEnrollmentPeriodIdOptimizedError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetBoundaryMapByEnrollmentPeriodIdOptimizedData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetBoundaryMapByEnrollmentPeriodIdOptimizedKeyFn(
      clientOptions,
      queryKey
    ),
    queryFn: () =>
      getBoundaryMapByEnrollmentPeriodIdOptimized({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetCapacitiesBySchoolAndEnrollmentPeriod = <
  TData = Common.GetCapacitiesBySchoolAndEnrollmentPeriodDefaultResponse,
  TError = GetCapacitiesBySchoolAndEnrollmentPeriodError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetCapacitiesBySchoolAndEnrollmentPeriodData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetCapacitiesBySchoolAndEnrollmentPeriodKeyFn(
      clientOptions,
      queryKey
    ),
    queryFn: () =>
      getCapacitiesBySchoolAndEnrollmentPeriod({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useListCapacitiesBySchoolAndEnrollmentPeriod = <
  TData = Common.ListCapacitiesBySchoolAndEnrollmentPeriodDefaultResponse,
  TError = ListCapacitiesBySchoolAndEnrollmentPeriodError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<ListCapacitiesBySchoolAndEnrollmentPeriodData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseListCapacitiesBySchoolAndEnrollmentPeriodKeyFn(
      clientOptions,
      queryKey
    ),
    queryFn: () =>
      listCapacitiesBySchoolAndEnrollmentPeriod({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useListCapacitiesByEnrollmentPeriod = <
  TData = Common.ListCapacitiesByEnrollmentPeriodDefaultResponse,
  TError = ListCapacitiesByEnrollmentPeriodError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<ListCapacitiesByEnrollmentPeriodData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseListCapacitiesByEnrollmentPeriodKeyFn(
      clientOptions,
      queryKey
    ),
    queryFn: () =>
      listCapacitiesByEnrollmentPeriod({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetCapacitiesConfigByEnrollmentPeriod = <
  TData = Common.GetCapacitiesConfigByEnrollmentPeriodDefaultResponse,
  TError = GetCapacitiesConfigByEnrollmentPeriodError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetCapacitiesConfigByEnrollmentPeriodData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetCapacitiesConfigByEnrollmentPeriodKeyFn(
      clientOptions,
      queryKey
    ),
    queryFn: () =>
      getCapacitiesConfigByEnrollmentPeriod({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetCapacitySummaryByEnrollmentPeriod = <
  TData = Common.GetCapacitySummaryByEnrollmentPeriodDefaultResponse,
  TError = GetCapacitySummaryByEnrollmentPeriodError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetCapacitySummaryByEnrollmentPeriodData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetCapacitySummaryByEnrollmentPeriodKeyFn(
      clientOptions,
      queryKey
    ),
    queryFn: () =>
      getCapacitySummaryByEnrollmentPeriod({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetCapacitiesHistory = <
  TData = Common.GetCapacitiesHistoryDefaultResponse,
  TError = GetCapacitiesHistoryError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetCapacitiesHistoryData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetCapacitiesHistoryKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getCapacitiesHistory({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetCapacitiesHistoryDetail = <
  TData = Common.GetCapacitiesHistoryDetailDefaultResponse,
  TError = GetCapacitiesHistoryDetailError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetCapacitiesHistoryDetailData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetCapacitiesHistoryDetailKeyFn(
      clientOptions,
      queryKey
    ),
    queryFn: () =>
      getCapacitiesHistoryDetail({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetSchools = <
  TData = Common.GetSchoolsDefaultResponse,
  TError = GetSchoolsError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetSchoolsData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetSchoolsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getSchools({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetSchoolsByEnrollmentPeriod = <
  TData = Common.GetSchoolsByEnrollmentPeriodDefaultResponse,
  TError = GetSchoolsByEnrollmentPeriodError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetSchoolsByEnrollmentPeriodData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetSchoolsByEnrollmentPeriodKeyFn(
      clientOptions,
      queryKey
    ),
    queryFn: () =>
      getSchoolsByEnrollmentPeriod({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetDashboardFormStatus = <
  TData = Common.GetDashboardFormStatusDefaultResponse,
  TError = GetDashboardFormStatusError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetDashboardFormStatusData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetDashboardFormStatusKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getDashboardFormStatus({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetDashboardFormSubstatus = <
  TData = Common.GetDashboardFormSubstatusDefaultResponse,
  TError = GetDashboardFormSubstatusError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetDashboardFormSubstatusData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetDashboardFormSubstatusKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getDashboardFormSubstatus({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetDashboardFormSchoolGradeRank = <
  TData = Common.GetDashboardFormSchoolGradeRankDefaultResponse,
  TError = GetDashboardFormSchoolGradeRankError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetDashboardFormSchoolGradeRankData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetDashboardFormSchoolGradeRankKeyFn(
      clientOptions,
      queryKey
    ),
    queryFn: () =>
      getDashboardFormSchoolGradeRank({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetDashboardFormResponsesOverTime = <
  TData = Common.GetDashboardFormResponsesOverTimeDefaultResponse,
  TError = GetDashboardFormResponsesOverTimeError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetDashboardFormResponsesOverTimeData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetDashboardFormResponsesOverTimeKeyFn(
      clientOptions,
      queryKey
    ),
    queryFn: () =>
      getDashboardFormResponsesOverTime({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetAdminGreeting = <
  TData = Common.GetAdminGreetingDefaultResponse,
  TError = GetAdminGreetingError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetAdminGreetingData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetAdminGreetingKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getAdminGreeting({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetGradeConfigByEnrollmentPeriod = <
  TData = Common.GetGradeConfigByEnrollmentPeriodDefaultResponse,
  TError = GetGradeConfigByEnrollmentPeriodError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetGradeConfigByEnrollmentPeriodData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetGradeConfigByEnrollmentPeriodKeyFn(
      clientOptions,
      queryKey
    ),
    queryFn: () =>
      getGradeConfigByEnrollmentPeriod({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useSearchApplicants = <
  TData = Common.SearchApplicantsDefaultResponse,
  TError = SearchApplicantsError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<SearchApplicantsData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseSearchApplicantsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      searchApplicants({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetFormAlertsByFormId = <
  TData = Common.GetFormAlertsByFormIdDefaultResponse,
  TError = GetFormAlertsByFormIdError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetFormAlertsByFormIdData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetFormAlertsByFormIdKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getFormAlertsByFormId({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useListUserGroups = <
  TData = Common.ListUserGroupsDefaultResponse,
  TError = ListUserGroupsError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<unknown, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseListUserGroupsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listUserGroups({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useListTeams = <
  TData = Common.ListTeamsDefaultResponse,
  TError = ListTeamsError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<ListTeamsData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseListTeamsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listTeams({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useListApiCredentials = <
  TData = Common.ListApiCredentialsDefaultResponse,
  TError = ListApiCredentialsError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<ListApiCredentialsData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseListApiCredentialsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listApiCredentials({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetApiCredential = <
  TData = Common.GetApiCredentialDefaultResponse,
  TError = GetApiCredentialError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetApiCredentialData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetApiCredentialKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getApiCredential({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetOrganizationConfig = <
  TData = Common.GetOrganizationConfigDefaultResponse,
  TError = GetOrganizationConfigError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetOrganizationConfigData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetOrganizationConfigKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getOrganizationConfig({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useListPaymentTemplates = <
  TData = Common.ListPaymentTemplatesDefaultResponse,
  TError = ListPaymentTemplatesError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<ListPaymentTemplatesData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseListPaymentTemplatesKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listPaymentTemplates({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetPaymentTemplate = <
  TData = Common.GetPaymentTemplateDefaultResponse,
  TError = GetPaymentTemplateError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetPaymentTemplateData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetPaymentTemplateKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getPaymentTemplate({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useListPayments = <
  TData = Common.ListPaymentsDefaultResponse,
  TError = ListPaymentsError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<ListPaymentsData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseListPaymentsKeyFn(clientOptions, queryKey),
    queryFn: () =>
      listPayments({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetAdminPaymentReceipt = <
  TData = Common.GetAdminPaymentReceiptDefaultResponse,
  TError = GetAdminPaymentReceiptError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetAdminPaymentReceiptData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetAdminPaymentReceiptKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getAdminPaymentReceipt({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetAdmissionsForMe = <
  TData = Common.GetAdmissionsForMeDefaultResponse,
  TError = GetAdmissionsForMeError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetAdmissionsForMeData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetAdmissionsForMeKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getAdmissionsForMe({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetOffersForMe = <
  TData = Common.GetOffersForMeDefaultResponse,
  TError = GetOffersForMeError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetOffersForMeData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetOffersForMeKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getOffersForMe({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetAnswersForMe = <
  TData = Common.GetAnswersForMeDefaultResponse,
  TError = GetAnswersForMeError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetAnswersForMeData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetAnswersForMeKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getAnswersForMe({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetEligibleFormTemplatesForMe = <
  TData = Common.GetEligibleFormTemplatesForMeDefaultResponse,
  TError = GetEligibleFormTemplatesForMeError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetEligibleFormTemplatesForMeData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetEligibleFormTemplatesForMeKeyFn(
      clientOptions,
      queryKey
    ),
    queryFn: () =>
      getEligibleFormTemplatesForMe({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetFormTemplateSettingsForMe = <
  TData = Common.GetFormTemplateSettingsForMeDefaultResponse,
  TError = GetFormTemplateSettingsForMeError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetFormTemplateSettingsForMeData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetFormTemplateSettingsForMeKeyFn(
      clientOptions,
      queryKey
    ),
    queryFn: () =>
      getFormTemplateSettingsForMe({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useParentGetBoundaryMapByFormId = <
  TData = Common.ParentGetBoundaryMapByFormIdDefaultResponse,
  TError = ParentGetBoundaryMapByFormIdError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<ParentGetBoundaryMapByFormIdData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseParentGetBoundaryMapByFormIdKeyFn(
      clientOptions,
      queryKey
    ),
    queryFn: () =>
      parentGetBoundaryMapByFormId({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useParentGetBoundaryMapByEnrollmentPeriodId = <
  TData = Common.ParentGetBoundaryMapByEnrollmentPeriodIdDefaultResponse,
  TError = ParentGetBoundaryMapByEnrollmentPeriodIdError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<ParentGetBoundaryMapByEnrollmentPeriodIdData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseParentGetBoundaryMapByEnrollmentPeriodIdKeyFn(
      clientOptions,
      queryKey
    ),
    queryFn: () =>
      parentGetBoundaryMapByEnrollmentPeriodId({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useParentGetBoundaryMapByFormIdOptimized = <
  TData = Common.ParentGetBoundaryMapByFormIdOptimizedDefaultResponse,
  TError = ParentGetBoundaryMapByFormIdOptimizedError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<ParentGetBoundaryMapByFormIdOptimizedData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseParentGetBoundaryMapByFormIdOptimizedKeyFn(
      clientOptions,
      queryKey
    ),
    queryFn: () =>
      parentGetBoundaryMapByFormIdOptimized({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useParentGetBoundaryMapByEnrollmentPeriodIdOptimized = <
  TData = Common.ParentGetBoundaryMapByEnrollmentPeriodIdOptimizedDefaultResponse,
  TError = ParentGetBoundaryMapByEnrollmentPeriodIdOptimizedError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<
    ParentGetBoundaryMapByEnrollmentPeriodIdOptimizedData,
    true
  >,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseParentGetBoundaryMapByEnrollmentPeriodIdOptimizedKeyFn(
      clientOptions,
      queryKey
    ),
    queryFn: () =>
      parentGetBoundaryMapByEnrollmentPeriodIdOptimized({
        ...clientOptions,
      }).then((response) => response.data as TData) as TData,
    ...options,
  });
export const useGetPaymentsForMe = <
  TData = Common.GetPaymentsForMeDefaultResponse,
  TError = GetPaymentsForMeError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetPaymentsForMeData, true>,
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetPaymentsForMeKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getPaymentsForMe({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetPaymentReceipt = <
  TData = Common.GetPaymentReceiptDefaultResponse,
  TError = GetPaymentReceiptError,
  TQueryKey extends Array<unknown> = unknown[]
>(
  clientOptions: Options<GetPaymentReceiptData, true> = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError | Error>, "queryKey" | "queryFn">
) =>
  useQuery<TData, TError | Error>({
    queryKey: Common.UseGetPaymentReceiptKeyFn(clientOptions, queryKey),
    queryFn: () =>
      getPaymentReceipt({ ...clientOptions }).then(
        (response) => response.data as TData
      ) as TData,
    ...options,
  });
export const useGetForms = <
  TData = Common.GetFormsMutationResult,
  TError = GetFormsError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<GetFormsData, true>, TContext>,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<GetFormsData, true>, TContext>({
    mutationKey: Common.UseGetFormsKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      getForms(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateBulkFormAction = <
  TData = Common.CreateBulkFormActionMutationResult,
  TError = CreateBulkFormActionError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<CreateBulkFormActionData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<CreateBulkFormActionData, true>, TContext>(
    {
      mutationKey: Common.UseCreateBulkFormActionKeyFn(mutationKey),
      mutationFn: (clientOptions) =>
        createBulkFormAction(clientOptions) as unknown as Promise<TData>,
      ...options,
    }
  );
export const useGeocodeAnswer = <
  TData = Common.GeocodeAnswerMutationResult,
  TError = GeocodeAnswerError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<GeocodeAnswerData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<GeocodeAnswerData, true>, TContext>({
    mutationKey: Common.UseGeocodeAnswerKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      geocodeAnswer(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useBulkMakeOffers = <
  TData = Common.BulkMakeOffersMutationResult,
  TError = BulkMakeOffersError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<BulkMakeOffersData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<BulkMakeOffersData, true>, TContext>({
    mutationKey: Common.UseBulkMakeOffersKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      bulkMakeOffers(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useBulkGetOfferExpirationInfo = <
  TData = Common.BulkGetOfferExpirationInfoMutationResult,
  TError = BulkGetOfferExpirationInfoError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<BulkGetOfferExpirationInfoData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<BulkGetOfferExpirationInfoData, true>,
    TContext
  >({
    mutationKey: Common.UseBulkGetOfferExpirationInfoKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      bulkGetOfferExpirationInfo(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateBulkOfferAction = <
  TData = Common.CreateBulkOfferActionMutationResult,
  TError = CreateBulkOfferActionError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<CreateBulkOfferActionData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<CreateBulkOfferActionData, true>,
    TContext
  >({
    mutationKey: Common.UseCreateBulkOfferActionKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createBulkOfferAction(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateOfferConfiguration = <
  TData = Common.CreateOfferConfigurationMutationResult,
  TError = CreateOfferConfigurationError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<CreateOfferConfigurationData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<CreateOfferConfigurationData, true>,
    TContext
  >({
    mutationKey: Common.UseCreateOfferConfigurationKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createOfferConfiguration(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const usePostWaitlists = <
  TData = Common.PostWaitlistsMutationResult,
  TError = PostWaitlistsError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<PostWaitlistsData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<PostWaitlistsData, true>, TContext>({
    mutationKey: Common.UsePostWaitlistsKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      postWaitlists(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateBulkWaitlistAction = <
  TData = Common.CreateBulkWaitlistActionMutationResult,
  TError = CreateBulkWaitlistActionError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<CreateBulkWaitlistActionData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<CreateBulkWaitlistActionData, true>,
    TContext
  >({
    mutationKey: Common.UseCreateBulkWaitlistActionKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createBulkWaitlistAction(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateBulkSubstatusAction = <
  TData = Common.CreateBulkSubstatusActionMutationResult,
  TError = CreateBulkSubstatusActionError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<CreateBulkSubstatusActionData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<CreateBulkSubstatusActionData, true>,
    TContext
  >({
    mutationKey: Common.UseCreateBulkSubstatusActionKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createBulkSubstatusAction(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useListAllowedSubStatusTransitions = <
  TData = Common.ListAllowedSubStatusTransitionsMutationResult,
  TError = ListAllowedSubStatusTransitionsError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<ListAllowedSubStatusTransitionsData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<ListAllowedSubStatusTransitionsData, true>,
    TContext
  >({
    mutationKey: Common.UseListAllowedSubStatusTransitionsKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      listAllowedSubStatusTransitions(
        clientOptions
      ) as unknown as Promise<TData>,
    ...options,
  });
export const useGeocodeForms = <
  TData = Common.GeocodeFormsMutationResult,
  TError = GeocodeFormsError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<GeocodeFormsData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<GeocodeFormsData, true>, TContext>({
    mutationKey: Common.UseGeocodeFormsKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      geocodeForms(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useListFormsAdvanced = <
  TData = Common.ListFormsAdvancedMutationResult,
  TError = ListFormsAdvancedError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<ListFormsAdvancedData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<ListFormsAdvancedData, true>, TContext>({
    mutationKey: Common.UseListFormsAdvancedKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      listFormsAdvanced(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useListFormsFromSelection = <
  TData = Common.ListFormsFromSelectionMutationResult,
  TError = ListFormsFromSelectionError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<ListFormsFromSelectionData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<ListFormsFromSelectionData, true>,
    TContext
  >({
    mutationKey: Common.UseListFormsFromSelectionKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      listFormsFromSelection(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useListFormIdsAdvanced = <
  TData = Common.ListFormIdsAdvancedMutationResult,
  TError = ListFormIdsAdvancedError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<ListFormIdsAdvancedData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<ListFormIdsAdvancedData, true>, TContext>({
    mutationKey: Common.UseListFormIdsAdvancedKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      listFormIdsAdvanced(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useListFormIdsAdvancedV2 = <
  TData = Common.ListFormIdsAdvancedV2MutationResult,
  TError = ListFormIdsAdvancedV2Error,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<ListFormIdsAdvancedV2Data, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<ListFormIdsAdvancedV2Data, true>,
    TContext
  >({
    mutationKey: Common.UseListFormIdsAdvancedV2KeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      listFormIdsAdvancedV2(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useAddFormTag = <
  TData = Common.AddFormTagMutationResult,
  TError = AddFormTagError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<AddFormTagData, true>, TContext>,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<AddFormTagData, true>, TContext>({
    mutationKey: Common.UseAddFormTagKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      addFormTag(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateBulkFormTagAction = <
  TData = Common.CreateBulkFormTagActionMutationResult,
  TError = CreateBulkFormTagActionError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<CreateBulkFormTagActionData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<CreateBulkFormTagActionData, true>,
    TContext
  >({
    mutationKey: Common.UseCreateBulkFormTagActionKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createBulkFormTagAction(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useAddFormSchoolTag = <
  TData = Common.AddFormSchoolTagMutationResult,
  TError = AddFormSchoolTagError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<AddFormSchoolTagData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<AddFormSchoolTagData, true>, TContext>({
    mutationKey: Common.UseAddFormSchoolTagKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      addFormSchoolTag(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateTagGroup = <
  TData = Common.CreateTagGroupMutationResult,
  TError = CreateTagGroupError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<CreateTagGroupData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<CreateTagGroupData, true>, TContext>({
    mutationKey: Common.UseCreateTagGroupKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createTagGroup(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateTag = <
  TData = Common.CreateTagMutationResult,
  TError = CreateTagError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CreateTagData, true>, TContext>,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<CreateTagData, true>, TContext>({
    mutationKey: Common.UseCreateTagKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createTag(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateRuleExecutions = <
  TData = Common.CreateRuleExecutionsMutationResult,
  TError = CreateRuleExecutionsError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<CreateRuleExecutionsData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<CreateRuleExecutionsData, true>, TContext>(
    {
      mutationKey: Common.UseCreateRuleExecutionsKeyFn(mutationKey),
      mutationFn: (clientOptions) =>
        createRuleExecutions(clientOptions) as unknown as Promise<TData>,
      ...options,
    }
  );
export const useImportRuleConfiguration = <
  TData = Common.ImportRuleConfigurationMutationResult,
  TError = ImportRuleConfigurationError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<ImportRuleConfigurationData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<ImportRuleConfigurationData, true>,
    TContext
  >({
    mutationKey: Common.UseImportRuleConfigurationKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      importRuleConfiguration(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateFormTemplate = <
  TData = Common.CreateFormTemplateMutationResult,
  TError = CreateFormTemplateError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<CreateFormTemplateData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<CreateFormTemplateData, true>, TContext>({
    mutationKey: Common.UseCreateFormTemplateKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createFormTemplate(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDiffFormSchema = <
  TData = Common.DiffFormSchemaMutationResult,
  TError = DiffFormSchemaError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<DiffFormSchemaData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<DiffFormSchemaData, true>, TContext>({
    mutationKey: Common.UseDiffFormSchemaKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      diffFormSchema(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useValidateFormSchema = <
  TData = Common.ValidateFormSchemaMutationResult,
  TError = ValidateFormSchemaError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<ValidateFormSchemaData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<ValidateFormSchemaData, true>, TContext>({
    mutationKey: Common.UseValidateFormSchemaKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      validateFormSchema(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const usePublishFormSchema = <
  TData = Common.PublishFormSchemaMutationResult,
  TError = PublishFormSchemaError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<PublishFormSchemaData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<PublishFormSchemaData, true>, TContext>({
    mutationKey: Common.UsePublishFormSchemaKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      publishFormSchema(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useImportFormTemplateFromJson = <
  TData = Common.ImportFormTemplateFromJsonMutationResult,
  TError = ImportFormTemplateFromJsonError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<ImportFormTemplateFromJsonData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<ImportFormTemplateFromJsonData, true>,
    TContext
  >({
    mutationKey: Common.UseImportFormTemplateFromJsonKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      importFormTemplateFromJson(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useImportFormTemplateFromOther = <
  TData = Common.ImportFormTemplateFromOtherMutationResult,
  TError = ImportFormTemplateFromOtherError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<ImportFormTemplateFromOtherData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<ImportFormTemplateFromOtherData, true>,
    TContext
  >({
    mutationKey: Common.UseImportFormTemplateFromOtherKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      importFormTemplateFromOther(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateFormRule = <
  TData = Common.CreateFormRuleMutationResult,
  TError = CreateFormRuleError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<CreateFormRuleData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<CreateFormRuleData, true>, TContext>({
    mutationKey: Common.UseCreateFormRuleKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createFormRule(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useImportMessageTemplates = <
  TData = Common.ImportMessageTemplatesMutationResult,
  TError = ImportMessageTemplatesError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<ImportMessageTemplatesData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<ImportMessageTemplatesData, true>,
    TContext
  >({
    mutationKey: Common.UseImportMessageTemplatesKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      importMessageTemplates(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useImportMessageTemplatesFromOther = <
  TData = Common.ImportMessageTemplatesFromOtherMutationResult,
  TError = ImportMessageTemplatesFromOtherError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<ImportMessageTemplatesFromOtherData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<ImportMessageTemplatesFromOtherData, true>,
    TContext
  >({
    mutationKey: Common.UseImportMessageTemplatesFromOtherKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      importMessageTemplatesFromOther(
        clientOptions
      ) as unknown as Promise<TData>,
    ...options,
  });
export const useImportSchoolsAndGradesForEnrollmentPeriod = <
  TData = Common.ImportSchoolsAndGradesForEnrollmentPeriodMutationResult,
  TError = ImportSchoolsAndGradesForEnrollmentPeriodError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<ImportSchoolsAndGradesForEnrollmentPeriodData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<ImportSchoolsAndGradesForEnrollmentPeriodData, true>,
    TContext
  >({
    mutationKey:
      Common.UseImportSchoolsAndGradesForEnrollmentPeriodKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      importSchoolsAndGradesForEnrollmentPeriod(
        clientOptions
      ) as unknown as Promise<TData>,
    ...options,
  });
export const useImportSchoolsAndGradesFromOthersForEnrollmentPeriod = <
  TData = Common.ImportSchoolsAndGradesFromOthersForEnrollmentPeriodMutationResult,
  TError = ImportSchoolsAndGradesFromOthersForEnrollmentPeriodError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<ImportSchoolsAndGradesFromOthersForEnrollmentPeriodData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<ImportSchoolsAndGradesFromOthersForEnrollmentPeriodData, true>,
    TContext
  >({
    mutationKey:
      Common.UseImportSchoolsAndGradesFromOthersForEnrollmentPeriodKeyFn(
        mutationKey
      ),
    mutationFn: (clientOptions) =>
      importSchoolsAndGradesFromOthersForEnrollmentPeriod(
        clientOptions
      ) as unknown as Promise<TData>,
    ...options,
  });
export const useImportSchoolBoundaryConnections = <
  TData = Common.ImportSchoolBoundaryConnectionsMutationResult,
  TError = ImportSchoolBoundaryConnectionsError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<ImportSchoolBoundaryConnectionsData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<ImportSchoolBoundaryConnectionsData, true>,
    TContext
  >({
    mutationKey: Common.UseImportSchoolBoundaryConnectionsKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      importSchoolBoundaryConnections(
        clientOptions
      ) as unknown as Promise<TData>,
    ...options,
  });
export const useImportBoundaryConnectionsFromEnrollmentPeriod = <
  TData = Common.ImportBoundaryConnectionsFromEnrollmentPeriodMutationResult,
  TError = ImportBoundaryConnectionsFromEnrollmentPeriodError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<ImportBoundaryConnectionsFromEnrollmentPeriodData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<ImportBoundaryConnectionsFromEnrollmentPeriodData, true>,
    TContext
  >({
    mutationKey:
      Common.UseImportBoundaryConnectionsFromEnrollmentPeriodKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      importBoundaryConnectionsFromEnrollmentPeriod(
        clientOptions
      ) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateOfferingCategories = <
  TData = Common.CreateOfferingCategoriesMutationResult,
  TError = CreateOfferingCategoriesError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<CreateOfferingCategoriesData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<CreateOfferingCategoriesData, true>,
    TContext
  >({
    mutationKey: Common.UseCreateOfferingCategoriesKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createOfferingCategories(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateOfferings = <
  TData = Common.CreateOfferingsMutationResult,
  TError = CreateOfferingsError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<CreateOfferingsData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<CreateOfferingsData, true>, TContext>({
    mutationKey: Common.UseCreateOfferingsKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createOfferings(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useAddOfferingSeatTypes = <
  TData = Common.AddOfferingSeatTypesMutationResult,
  TError = AddOfferingSeatTypesError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<AddOfferingSeatTypesData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<AddOfferingSeatTypesData, true>, TContext>(
    {
      mutationKey: Common.UseAddOfferingSeatTypesKeyFn(mutationKey),
      mutationFn: (clientOptions) =>
        addOfferingSeatTypes(clientOptions) as unknown as Promise<TData>,
      ...options,
    }
  );
export const useCreateBoundaryConnections = <
  TData = Common.CreateBoundaryConnectionsMutationResult,
  TError = CreateBoundaryConnectionsError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<CreateBoundaryConnectionsData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<CreateBoundaryConnectionsData, true>,
    TContext
  >({
    mutationKey: Common.UseCreateBoundaryConnectionsKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createBoundaryConnections(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const usePostBoundaries = <
  TData = Common.PostBoundariesMutationResult,
  TError = PostBoundariesError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<PostBoundariesData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<PostBoundariesData, true>, TContext>({
    mutationKey: Common.UsePostBoundariesKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      postBoundaries(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useExportCapacitiesBySchoolAndEnrollmentPeriod = <
  TData = Common.ExportCapacitiesBySchoolAndEnrollmentPeriodMutationResult,
  TError = ExportCapacitiesBySchoolAndEnrollmentPeriodError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<ExportCapacitiesBySchoolAndEnrollmentPeriodData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<ExportCapacitiesBySchoolAndEnrollmentPeriodData, true>,
    TContext
  >({
    mutationKey:
      Common.UseExportCapacitiesBySchoolAndEnrollmentPeriodKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      exportCapacitiesBySchoolAndEnrollmentPeriod(
        clientOptions
      ) as unknown as Promise<TData>,
    ...options,
  });
export const useExportCapacitiesByEnrollmentPeriod = <
  TData = Common.ExportCapacitiesByEnrollmentPeriodMutationResult,
  TError = ExportCapacitiesByEnrollmentPeriodError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<ExportCapacitiesByEnrollmentPeriodData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<ExportCapacitiesByEnrollmentPeriodData, true>,
    TContext
  >({
    mutationKey: Common.UseExportCapacitiesByEnrollmentPeriodKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      exportCapacitiesByEnrollmentPeriod(
        clientOptions
      ) as unknown as Promise<TData>,
    ...options,
  });
export const useImportCapacitiesByEnrollmentPeriod = <
  TData = Common.ImportCapacitiesByEnrollmentPeriodMutationResult,
  TError = ImportCapacitiesByEnrollmentPeriodError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<ImportCapacitiesByEnrollmentPeriodData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<ImportCapacitiesByEnrollmentPeriodData, true>,
    TContext
  >({
    mutationKey: Common.UseImportCapacitiesByEnrollmentPeriodKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      importCapacitiesByEnrollmentPeriod(
        clientOptions
      ) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateCapacitiesByEnrollmentPeriod = <
  TData = Common.UpdateCapacitiesByEnrollmentPeriodMutationResult,
  TError = UpdateCapacitiesByEnrollmentPeriodError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<UpdateCapacitiesByEnrollmentPeriodData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<UpdateCapacitiesByEnrollmentPeriodData, true>,
    TContext
  >({
    mutationKey: Common.UseUpdateCapacitiesByEnrollmentPeriodKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      updateCapacitiesByEnrollmentPeriod(
        clientOptions
      ) as unknown as Promise<TData>,
    ...options,
  });
export const usePublishMatchRun = <
  TData = Common.PublishMatchRunMutationResult,
  TError = PublishMatchRunError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<PublishMatchRunData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<PublishMatchRunData, true>, TContext>({
    mutationKey: Common.UsePublishMatchRunKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      publishMatchRun(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useResetTeamMemberMfa = <
  TData = Common.ResetTeamMemberMfaMutationResult,
  TError = ResetTeamMemberMfaError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<ResetTeamMemberMfaData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<ResetTeamMemberMfaData, true>, TContext>({
    mutationKey: Common.UseResetTeamMemberMfaKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      resetTeamMemberMfa(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateTeamMember = <
  TData = Common.CreateTeamMemberMutationResult,
  TError = CreateTeamMemberError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<CreateTeamMemberData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<CreateTeamMemberData, true>, TContext>({
    mutationKey: Common.UseCreateTeamMemberKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createTeamMember(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useSendPasswordReset = <
  TData = Common.SendPasswordResetMutationResult,
  TError = SendPasswordResetError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<SendPasswordResetData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<SendPasswordResetData, true>, TContext>({
    mutationKey: Common.UseSendPasswordResetKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      sendPasswordReset(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateApiCredential = <
  TData = Common.CreateApiCredentialMutationResult,
  TError = CreateApiCredentialError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<CreateApiCredentialData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<CreateApiCredentialData, true>, TContext>({
    mutationKey: Common.UseCreateApiCredentialKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createApiCredential(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useRotateApiCredentialSecret = <
  TData = Common.RotateApiCredentialSecretMutationResult,
  TError = RotateApiCredentialSecretError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<RotateApiCredentialSecretData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<RotateApiCredentialSecretData, true>,
    TContext
  >({
    mutationKey: Common.UseRotateApiCredentialSecretKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      rotateApiCredentialSecret(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateOrganization = <
  TData = Common.CreateOrganizationMutationResult,
  TError = CreateOrganizationError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<CreateOrganizationData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<CreateOrganizationData, true>, TContext>({
    mutationKey: Common.UseCreateOrganizationKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createOrganization(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useGenerateUploadUrl = <
  TData = Common.GenerateUploadUrlMutationResult,
  TError = GenerateUploadUrlError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<GenerateUploadUrlData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<GenerateUploadUrlData, true>, TContext>({
    mutationKey: Common.UseGenerateUploadUrlKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      generateUploadUrl(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useGenerateBannerImageUploadUrl = <
  TData = Common.GenerateBannerImageUploadUrlMutationResult,
  TError = GenerateBannerImageUploadUrlError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<GenerateBannerImageUploadUrlData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<GenerateBannerImageUploadUrlData, true>,
    TContext
  >({
    mutationKey: Common.UseGenerateBannerImageUploadUrlKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      generateBannerImageUploadUrl(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateOrganizationConfig = <
  TData = Common.UpdateOrganizationConfigMutationResult,
  TError = UpdateOrganizationConfigError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<UpdateOrganizationConfigData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<UpdateOrganizationConfigData, true>,
    TContext
  >({
    mutationKey: Common.UseUpdateOrganizationConfigKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      updateOrganizationConfig(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useConnectStripeAccount = <
  TData = Common.ConnectStripeAccountMutationResult,
  TError = ConnectStripeAccountError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<ConnectStripeAccountData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<ConnectStripeAccountData, true>, TContext>(
    {
      mutationKey: Common.UseConnectStripeAccountKeyFn(mutationKey),
      mutationFn: (clientOptions) =>
        connectStripeAccount(clientOptions) as unknown as Promise<TData>,
      ...options,
    }
  );
export const useDisconnectStripeAccount = <
  TData = Common.DisconnectStripeAccountMutationResult,
  TError = DisconnectStripeAccountError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<DisconnectStripeAccountData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<DisconnectStripeAccountData, true>,
    TContext
  >({
    mutationKey: Common.UseDisconnectStripeAccountKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      disconnectStripeAccount(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreatePaymentTemplate = <
  TData = Common.CreatePaymentTemplateMutationResult,
  TError = CreatePaymentTemplateError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<CreatePaymentTemplateData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<CreatePaymentTemplateData, true>,
    TContext
  >({
    mutationKey: Common.UseCreatePaymentTemplateKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createPaymentTemplate(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreatePayments = <
  TData = Common.CreatePaymentsMutationResult,
  TError = CreatePaymentsError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<CreatePaymentsData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<CreatePaymentsData, true>, TContext>({
    mutationKey: Common.UseCreatePaymentsKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createPayments(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateRuleExecutionsForMe = <
  TData = Common.CreateRuleExecutionsForMeMutationResult,
  TError = CreateRuleExecutionsForMeError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<CreateRuleExecutionsForMeData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<CreateRuleExecutionsForMeData, true>,
    TContext
  >({
    mutationKey: Common.UseCreateRuleExecutionsForMeKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createRuleExecutionsForMe(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useResendVerificationEmail = <
  TData = Common.ResendVerificationEmailMutationResult,
  TError = ResendVerificationEmailError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<ResendVerificationEmailData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<ResendVerificationEmailData, true>,
    TContext
  >({
    mutationKey: Common.UseResendVerificationEmailKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      resendVerificationEmail(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCheckout = <
  TData = Common.CheckoutMutationResult,
  TError = CheckoutError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<CheckoutData, true>, TContext>,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<CheckoutData, true>, TContext>({
    mutationKey: Common.UseCheckoutKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      checkout(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateFormsStatusForAdmin = <
  TData = Common.UpdateFormsStatusForAdminMutationResult,
  TError = UpdateFormsStatusForAdminError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<UpdateFormsStatusForAdminData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<UpdateFormsStatusForAdminData, true>,
    TContext
  >({
    mutationKey: Common.UseUpdateFormsStatusForAdminKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      updateFormsStatusForAdmin(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const usePutAnswers = <
  TData = Common.PutAnswersMutationResult,
  TError = PutAnswersError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<PutAnswersData, true>, TContext>,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<PutAnswersData, true>, TContext>({
    mutationKey: Common.UsePutAnswersKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      putAnswers(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const usePutAnswer = <
  TData = Common.PutAnswerMutationResult,
  TError = PutAnswerError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<PutAnswerData, true>, TContext>,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<PutAnswerData, true>, TContext>({
    mutationKey: Common.UsePutAnswerKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      putAnswer(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useBulkAcceptOffer = <
  TData = Common.BulkAcceptOfferMutationResult,
  TError = BulkAcceptOfferError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<BulkAcceptOfferData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<BulkAcceptOfferData, true>, TContext>({
    mutationKey: Common.UseBulkAcceptOfferKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      bulkAcceptOffer(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useBulkDeclineOffer = <
  TData = Common.BulkDeclineOfferMutationResult,
  TError = BulkDeclineOfferError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<BulkDeclineOfferData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<BulkDeclineOfferData, true>, TContext>({
    mutationKey: Common.UseBulkDeclineOfferKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      bulkDeclineOffer(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useBulkRevokeOffer = <
  TData = Common.BulkRevokeOfferMutationResult,
  TError = BulkRevokeOfferError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<BulkRevokeOfferData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<BulkRevokeOfferData, true>, TContext>({
    mutationKey: Common.UseBulkRevokeOfferKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      bulkRevokeOffer(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateOfferConfiguration = <
  TData = Common.UpdateOfferConfigurationMutationResult,
  TError = UpdateOfferConfigurationError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<UpdateOfferConfigurationData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<UpdateOfferConfigurationData, true>,
    TContext
  >({
    mutationKey: Common.UseUpdateOfferConfigurationKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      updateOfferConfiguration(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useExclude = <
  TData = Common.ExcludeMutationResult,
  TError = ExcludeError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<ExcludeData, true>, TContext>,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<ExcludeData, true>, TContext>({
    mutationKey: Common.UseExcludeKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      exclude(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateTagGroup = <
  TData = Common.UpdateTagGroupMutationResult,
  TError = UpdateTagGroupError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<UpdateTagGroupData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<UpdateTagGroupData, true>, TContext>({
    mutationKey: Common.UseUpdateTagGroupKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      updateTagGroup(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateTag = <
  TData = Common.UpdateTagMutationResult,
  TError = UpdateTagError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<UpdateTagData, true>, TContext>,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<UpdateTagData, true>, TContext>({
    mutationKey: Common.UseUpdateTagKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      updateTag(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateFormTemplate = <
  TData = Common.UpdateFormTemplateMutationResult,
  TError = UpdateFormTemplateError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<UpdateFormTemplateData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<UpdateFormTemplateData, true>, TContext>({
    mutationKey: Common.UseUpdateFormTemplateKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      updateFormTemplate(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateFormTemplateSettings = <
  TData = Common.UpdateFormTemplateSettingsMutationResult,
  TError = UpdateFormTemplateSettingsError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<UpdateFormTemplateSettingsData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<UpdateFormTemplateSettingsData, true>,
    TContext
  >({
    mutationKey: Common.UseUpdateFormTemplateSettingsKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      updateFormTemplateSettings(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateFormSchema = <
  TData = Common.UpdateFormSchemaMutationResult,
  TError = UpdateFormSchemaError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<UpdateFormSchemaData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<UpdateFormSchemaData, true>, TContext>({
    mutationKey: Common.UseUpdateFormSchemaKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      updateFormSchema(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateFormRule = <
  TData = Common.UpdateFormRuleMutationResult,
  TError = UpdateFormRuleError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<UpdateFormRuleData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<UpdateFormRuleData, true>, TContext>({
    mutationKey: Common.UseUpdateFormRuleKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      updateFormRule(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateFormRuleActiveStatus = <
  TData = Common.UpdateFormRuleActiveStatusMutationResult,
  TError = UpdateFormRuleActiveStatusError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<UpdateFormRuleActiveStatusData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<UpdateFormRuleActiveStatusData, true>,
    TContext
  >({
    mutationKey: Common.UseUpdateFormRuleActiveStatusKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      updateFormRuleActiveStatus(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateOfferingCategory = <
  TData = Common.UpdateOfferingCategoryMutationResult,
  TError = UpdateOfferingCategoryError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<UpdateOfferingCategoryData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<UpdateOfferingCategoryData, true>,
    TContext
  >({
    mutationKey: Common.UseUpdateOfferingCategoryKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      updateOfferingCategory(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateBoundaryConnections = <
  TData = Common.UpdateBoundaryConnectionsMutationResult,
  TError = UpdateBoundaryConnectionsError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<UpdateBoundaryConnectionsData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<UpdateBoundaryConnectionsData, true>,
    TContext
  >({
    mutationKey: Common.UseUpdateBoundaryConnectionsKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      updateBoundaryConnections(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateBoundaryById = <
  TData = Common.UpdateBoundaryByIdMutationResult,
  TError = UpdateBoundaryByIdError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<UpdateBoundaryByIdData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<UpdateBoundaryByIdData, true>, TContext>({
    mutationKey: Common.UseUpdateBoundaryByIdKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      updateBoundaryById(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateCapacitiesConfigByEnrollmentPeriod = <
  TData = Common.UpdateCapacitiesConfigByEnrollmentPeriodMutationResult,
  TError = UpdateCapacitiesConfigByEnrollmentPeriodError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<UpdateCapacitiesConfigByEnrollmentPeriodData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<UpdateCapacitiesConfigByEnrollmentPeriodData, true>,
    TContext
  >({
    mutationKey:
      Common.UseUpdateCapacitiesConfigByEnrollmentPeriodKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      updateCapacitiesConfigByEnrollmentPeriod(
        clientOptions
      ) as unknown as Promise<TData>,
    ...options,
  });
export const useCreateLoginPrefillToken = <
  TData = Common.CreateLoginPrefillTokenMutationResult,
  TError = CreateLoginPrefillTokenError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<CreateLoginPrefillTokenData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<CreateLoginPrefillTokenData, true>,
    TContext
  >({
    mutationKey: Common.UseCreateLoginPrefillTokenKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      createLoginPrefillToken(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useEditTeamMember = <
  TData = Common.EditTeamMemberMutationResult,
  TError = EditTeamMemberError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<EditTeamMemberData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<EditTeamMemberData, true>, TContext>({
    mutationKey: Common.UseEditTeamMemberKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      editTeamMember(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdateApiCredential = <
  TData = Common.UpdateApiCredentialMutationResult,
  TError = UpdateApiCredentialError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<UpdateApiCredentialData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<UpdateApiCredentialData, true>, TContext>({
    mutationKey: Common.UseUpdateApiCredentialKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      updateApiCredential(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useCancelPayment = <
  TData = Common.CancelPaymentMutationResult,
  TError = CancelPaymentError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<CancelPaymentData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<CancelPaymentData, true>, TContext>({
    mutationKey: Common.UseCancelPaymentKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      cancelPayment(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useWithdrawFromWaitlist = <
  TData = Common.WithdrawFromWaitlistMutationResult,
  TError = WithdrawFromWaitlistError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<WithdrawFromWaitlistData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<WithdrawFromWaitlistData, true>, TContext>(
    {
      mutationKey: Common.UseWithdrawFromWaitlistKeyFn(mutationKey),
      mutationFn: (clientOptions) =>
        withdrawFromWaitlist(clientOptions) as unknown as Promise<TData>,
      ...options,
    }
  );
export const useAcceptOffer = <
  TData = Common.AcceptOfferMutationResult,
  TError = AcceptOfferError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<AcceptOfferData, true>, TContext>,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<AcceptOfferData, true>, TContext>({
    mutationKey: Common.UseAcceptOfferKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      acceptOffer(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeclineOffer = <
  TData = Common.DeclineOfferMutationResult,
  TError = DeclineOfferError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<DeclineOfferData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<DeclineOfferData, true>, TContext>({
    mutationKey: Common.UseDeclineOfferKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      declineOffer(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const usePutAnswersForMe = <
  TData = Common.PutAnswersForMeMutationResult,
  TError = PutAnswersForMeError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<PutAnswersForMeData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<PutAnswersForMeData, true>, TContext>({
    mutationKey: Common.UsePutAnswersForMeKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      putAnswersForMe(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const usePutAnswerForMe = <
  TData = Common.PutAnswerForMeMutationResult,
  TError = PutAnswerForMeError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<PutAnswerForMeData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<PutAnswerForMeData, true>, TContext>({
    mutationKey: Common.UsePutAnswerForMeKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      putAnswerForMe(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useResetFormForMe = <
  TData = Common.ResetFormForMeMutationResult,
  TError = ResetFormForMeError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<ResetFormForMeData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<ResetFormForMeData, true>, TContext>({
    mutationKey: Common.UseResetFormForMeKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      resetFormForMe(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useSubmitFormForMe = <
  TData = Common.SubmitFormForMeMutationResult,
  TError = SubmitFormForMeError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<SubmitFormForMeData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<SubmitFormForMeData, true>, TContext>({
    mutationKey: Common.UseSubmitFormForMeKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      submitFormForMe(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteFormForMe = <
  TData = Common.DeleteFormForMeMutationResult,
  TError = DeleteFormForMeError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<DeleteFormForMeData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<DeleteFormForMeData, true>, TContext>({
    mutationKey: Common.UseDeleteFormForMeKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      deleteFormForMe(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useBulkSetOfferExpiration = <
  TData = Common.BulkSetOfferExpirationMutationResult,
  TError = BulkSetOfferExpirationError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<BulkSetOfferExpirationData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<BulkSetOfferExpirationData, true>,
    TContext
  >({
    mutationKey: Common.UseBulkSetOfferExpirationKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      bulkSetOfferExpiration(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useArchiveTeamMembers = <
  TData = Common.ArchiveTeamMembersMutationResult,
  TError = ArchiveTeamMembersError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<ArchiveTeamMembersData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<ArchiveTeamMembersData, true>, TContext>({
    mutationKey: Common.UseArchiveTeamMembersKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      archiveTeamMembers(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useUpdatePaymentTemplate = <
  TData = Common.UpdatePaymentTemplateMutationResult,
  TError = UpdatePaymentTemplateError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<UpdatePaymentTemplateData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<UpdatePaymentTemplateData, true>,
    TContext
  >({
    mutationKey: Common.UseUpdatePaymentTemplateKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      updatePaymentTemplate(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useClearAnswer = <
  TData = Common.ClearAnswerMutationResult,
  TError = ClearAnswerError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<ClearAnswerData, true>, TContext>,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<ClearAnswerData, true>, TContext>({
    mutationKey: Common.UseClearAnswerKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      clearAnswer(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteOfferConfiguration = <
  TData = Common.DeleteOfferConfigurationMutationResult,
  TError = DeleteOfferConfigurationError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<DeleteOfferConfigurationData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<DeleteOfferConfigurationData, true>,
    TContext
  >({
    mutationKey: Common.UseDeleteOfferConfigurationKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      deleteOfferConfiguration(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteWaitlists = <
  TData = Common.DeleteWaitlistsMutationResult,
  TError = DeleteWaitlistsError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<DeleteWaitlistsData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<DeleteWaitlistsData, true>, TContext>({
    mutationKey: Common.UseDeleteWaitlistsKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      deleteWaitlists(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useClearSubStatus = <
  TData = Common.ClearSubStatusMutationResult,
  TError = ClearSubStatusError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<ClearSubStatusData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<ClearSubStatusData, true>, TContext>({
    mutationKey: Common.UseClearSubStatusKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      clearSubStatus(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useRemoveFormTag = <
  TData = Common.RemoveFormTagMutationResult,
  TError = RemoveFormTagError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<RemoveFormTagData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<RemoveFormTagData, true>, TContext>({
    mutationKey: Common.UseRemoveFormTagKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      removeFormTag(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useRemoveFormSchoolTag = <
  TData = Common.RemoveFormSchoolTagMutationResult,
  TError = RemoveFormSchoolTagError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<RemoveFormSchoolTagData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<RemoveFormSchoolTagData, true>, TContext>({
    mutationKey: Common.UseRemoveFormSchoolTagKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      removeFormSchoolTag(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteTagGroup = <
  TData = Common.DeleteTagGroupMutationResult,
  TError = DeleteTagGroupError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<DeleteTagGroupData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<DeleteTagGroupData, true>, TContext>({
    mutationKey: Common.UseDeleteTagGroupKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      deleteTagGroup(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteTag = <
  TData = Common.DeleteTagMutationResult,
  TError = DeleteTagError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<TData, TError, Options<DeleteTagData, true>, TContext>,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<DeleteTagData, true>, TContext>({
    mutationKey: Common.UseDeleteTagKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      deleteTag(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteUnpublishedFormSchema = <
  TData = Common.DeleteUnpublishedFormSchemaMutationResult,
  TError = DeleteUnpublishedFormSchemaError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<DeleteUnpublishedFormSchemaData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<DeleteUnpublishedFormSchemaData, true>,
    TContext
  >({
    mutationKey: Common.UseDeleteUnpublishedFormSchemaKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      deleteUnpublishedFormSchema(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteFormRule = <
  TData = Common.DeleteFormRuleMutationResult,
  TError = DeleteFormRuleError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<DeleteFormRuleData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<DeleteFormRuleData, true>, TContext>({
    mutationKey: Common.UseDeleteFormRuleKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      deleteFormRule(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteOfferingCategory = <
  TData = Common.DeleteOfferingCategoryMutationResult,
  TError = DeleteOfferingCategoryError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<DeleteOfferingCategoryData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<DeleteOfferingCategoryData, true>,
    TContext
  >({
    mutationKey: Common.UseDeleteOfferingCategoryKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      deleteOfferingCategory(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteOffering = <
  TData = Common.DeleteOfferingMutationResult,
  TError = DeleteOfferingError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<DeleteOfferingData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<DeleteOfferingData, true>, TContext>({
    mutationKey: Common.UseDeleteOfferingKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      deleteOffering(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteOfferingSeatType = <
  TData = Common.DeleteOfferingSeatTypeMutationResult,
  TError = DeleteOfferingSeatTypeError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<DeleteOfferingSeatTypeData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<DeleteOfferingSeatTypeData, true>,
    TContext
  >({
    mutationKey: Common.UseDeleteOfferingSeatTypeKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      deleteOfferingSeatType(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteBoundaryConnections = <
  TData = Common.DeleteBoundaryConnectionsMutationResult,
  TError = DeleteBoundaryConnectionsError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<DeleteBoundaryConnectionsData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<DeleteBoundaryConnectionsData, true>,
    TContext
  >({
    mutationKey: Common.UseDeleteBoundaryConnectionsKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      deleteBoundaryConnections(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteBoundaries = <
  TData = Common.DeleteBoundariesMutationResult,
  TError = DeleteBoundariesError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<DeleteBoundariesData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<DeleteBoundariesData, true>, TContext>({
    mutationKey: Common.UseDeleteBoundariesKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      deleteBoundaries(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeleteApiCredential = <
  TData = Common.DeleteApiCredentialMutationResult,
  TError = DeleteApiCredentialError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<DeleteApiCredentialData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<DeleteApiCredentialData, true>, TContext>({
    mutationKey: Common.UseDeleteApiCredentialKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      deleteApiCredential(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useDeletePaymentTemplate = <
  TData = Common.DeletePaymentTemplateMutationResult,
  TError = DeletePaymentTemplateError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<DeletePaymentTemplateData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<
    TData,
    TError,
    Options<DeletePaymentTemplateData, true>,
    TContext
  >({
    mutationKey: Common.UseDeletePaymentTemplateKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      deletePaymentTemplate(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
export const useClearAnswerForMe = <
  TData = Common.ClearAnswerForMeMutationResult,
  TError = ClearAnswerForMeError,
  TQueryKey extends Array<unknown> = unknown[],
  TContext = unknown
>(
  mutationKey?: TQueryKey,
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      Options<ClearAnswerForMeData, true>,
      TContext
    >,
    "mutationKey" | "mutationFn"
  >
) =>
  useMutation<TData, TError, Options<ClearAnswerForMeData, true>, TContext>({
    mutationKey: Common.UseClearAnswerForMeKeyFn(mutationKey),
    mutationFn: (clientOptions) =>
      clearAnswerForMe(clientOptions) as unknown as Promise<TData>,
    ...options,
  });
